<template>
  <scroll-center-dialog v-model="opened" :loading="save_loading" @close="close" @apply="save" :title="form_title" :scrolled="false">
    <div v-if="!loading">
      <loading-autocomplete
          v-if="!edit"
          class="mt-4"
          outlined
          placeholder="Введите ФИО и выберете из предложенных вариантов"
          label="Пользователь"
          v-model="ban.user"
          search-parameter="fio"
          required
          :load-fios="false"
          :url="user_selector"
          :error="hasError('user')"
          :errorMessages="getError('user')"
      >
        <template v-slot:no-data>
          <div>
            Для поиска начните набирать ФИО, <br> и подождите 1 секунду, либо нажмите Enter
          </div>
        </template>
      </loading-autocomplete>
      <date-picker
          :class="edit ? 'mt-4' : ''"
          key="auto_unban"
          v-model="ban.auto_unban"
          label="Дата окончания"
          outlined
          prepend-outer-icon
          icon="calendar_month"
          :allowed-dates="disablePastDates"
          :date-static-lower="ban.auto_unban"
          :error="hasError('auto_unban')"
          :errorMessages="getError('auto_unban')"
      ></date-picker>
      <v-text-field
          v-model="ban.reason"
          label="Причина"
          outlined
          :error="hasError('reason')"
          :errorMessages="getError('reason')"
          class="mb-n2"
      >
        <template v-slot:label>
          Причина
<!--          <strong class="red&#45;&#45;text">*</strong>-->
        </template>
      </v-text-field>
    </div>
    <div class="action mt-8 mb-4 align-center" v-else>
      <semipolar-spinner
          class="d-inline-block"
          :animation-duration="2000"
          :size="115"
          color="#1935ff"
      />
    </div>
  </scroll-center-dialog>
</template>

<script>
import FormErrorsMixin from "@/mixins/FormErrorsMixin"
import {mapActions} from "vuex";
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog";
import PaginatedDataMapperMixin from "@/mixins/PaginatedDataMapperMixin";
import selectors from "@/urls/selectors";
import {SemipolarSpinner} from "epic-spinners";
import bans from "@/store/modules/admin/bans";
import LoadingAutocomplete from "@/modules/core/components/LoadingAutocomplete.vue";
import datePicker from "@/modules/core/components/DatePicker.vue";

export default {
  name: "BanesEditDialog",
  props: {
    opened: Boolean,
    edit: Boolean,
    BanData: Object
  },
  mixins: [FormErrorsMixin, PaginatedDataMapperMixin],
  components: {
    datePicker,
    ScrollCenterDialog,
    LoadingAutocomplete,
    SemipolarSpinner
  },
  data() {
    return {
      loading: false,
      save_loading: false,
      ban_default: {
        user: null,
        reason: "",
        auto_unban: undefined
      },
      ban: undefined
    }
  },
  watch: {},
  computed: {
    bans() {
      return bans
    },
    form_title() {
      return this.edit === false ? "Заблокировать пользователя" : "Редактировать причину"
    },
    user_selector(){
      return selectors.SELECTORS.USERS.ALL()
    }
  },
  methods: {
    ...mapActions({
      createBan: "admin/createBans",
      changeBan: "admin/changeBans"
    }),
    close(){
      this.$emit("close", false)
    },
    loadBanData(){
      this.loading = true
      if(this.BanData === undefined){
        this.ban = this.ban_default
        this.loading = false
      }
      else{
        this.ban = JSON.parse(JSON.stringify(this.BanData))
        this.loading = false
      }
    },
    save(){
      this.save_loading = true

      if (this.edit) {
        this.changeBan({
          id: this.ban.id,
          data: this.ban,
          finalizer: () => {
            this.$emit("close", this.ban)
            this.save_loading = false
          },
          catcher:(val) => {
            this.mapErrors(val)
            this.save_loading = false
          }
        })
      } else {
        this.createBan({
          data: this.ban,
          finalizer: () => {
            this.$emit("close", this.ban)
            this.save_loading = false
          },
          catcher:(val) => {
            this.mapErrors(val)
            this.save_loading = false
          }
        })
      }
    },
    disablePastDates(val) {
      return val >= new Date().toISOString().split("T")[0]
    }
  },
  created() {
    this.loadBanData()
  }
}
</script>

<style scoped>

</style>
